import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import LoginAsSAdminComponent from "../../components/Auth/LoginAsSAdminComponent";

const LoginAsAdminPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectHome = () => {
        navigate('/admin');
    }

    return <LoginAsSAdminComponent email={ params.email } redirectHome={redirectHome} />;
}

export default LoginAsAdminPage;